import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const fileUrl = (storagePath) => `${API}/files/${storagePath}`;

export const waLink = (number, text) =>
  `https://wa.me/${String(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export const scrollToId = (id) => {
  const target = document.getElementById(id);
  if (!target) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -70, duration: 1.4 });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
};
